module.exports = __webpack_public_path__ + "img/icon_cash_p.804bec0a.png";